import { render } from "./HeaderUI.vue?vue&type=template&id=96ac56f2"
import script from "./HeaderUI.vue?vue&type=script&lang=js"
export * from "./HeaderUI.vue?vue&type=script&lang=js"

import "./HeaderUI.vue?vue&type=style&index=0&id=96ac56f2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__